// Conteúdo da página Sobre. Função para que a quantidade de apps e setores
// venha do catálogo no build, em vez de número fixo que envelhece.
export const SobreBody = ({ appsCount, sectorsCount }: { appsCount: number; sectorsCount: number }): string => String.raw`
<section class="page-hero"><div class="hero-grid-bg"></div>
  <div class="shell page-hero-in rev">
    <h1>Operação de WhatsApp sem gambiarra.</h1>
    <p class="lead">A Operax existe pra PME brasileira parar de costurar cinco ferramentas. Uma plataforma no WhatsApp oficial da Meta, com custo transparente e dados que continuam seus.</p>
  </div>
</section>

<section class="pad">
  <div class="shell">
    <div class="split">
      <div class="prose rev">
        <div class="eyebrow">Quem somos</div>
        <h2>Uma plataforma, não mais um sistema pra gerenciar.</h2>
        <p>Muita PME atende no WhatsApp, vende na planilha, cobra num app e emite nota em outro. A Operax junta isso num login só, pela Cloud API oficial da Meta.</p>
        <p>Somos <strong>Provedor de Tecnologia verificado pela Meta</strong>: a conexão é pela Cloud API oficial, e a taxa da Meta é cobrada direto na conta da sua empresa, só pelas mensagens de modelo entregues. Sem celular plugado, sem risco desnecessário de bloqueio.</p>
        <p>O compromisso é direto: custo claro, respeito aos dados e liberdade de sair levando o histórico se um dia deixar de fazer sentido.</p>
      </div>
      <div class="rev" style="align-self:start">
        <div class="navy-badge" style="background:#0a1122;color:#cdd9f0;border-color:rgba(120,170,255,.25);margin-bottom:16px"><span class="meta-dot"><svg viewBox="0 0 24 24" fill="#fff"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-8 11-6-4v-1l6 4 6-4v1z"/></svg></span>WhatsApp oficial · Provedor de Tecnologia Meta</div>
        <div class="facts">
          <div class="f"><div class="k">Razão social</div><div class="v">CASTOR CONSULTORIA E DESENVOLVIMENTO LTDA - ME</div></div>
          <div class="f"><div class="k">CNPJ</div><div class="v">41.769.835/0001-98</div></div>
          <div class="f"><div class="k">Sede</div><div class="v">Timóteo/MG</div></div>
          <div class="f"><div class="k">Atividade</div><div class="v">Consultoria em tecnologia da informação</div></div>
          <div class="f"><div class="k">Atendimento</div><div class="v">Seg. a sex., 9h às 18h (Brasília)</div></div>
          <div class="f"><div class="k">Produto</div><div class="v">operax.digital</div></div>
        </div>
      </div>
    </div>
    <div class="statrow">
      <div class="s rev"><div class="n">${appsCount}</div><div class="l">apps no catálogo</div></div>
      <div class="s rev" style="transition-delay:.04s"><div class="n">${sectorsCount}</div><div class="l">setores atendidos</div></div>
      <div class="s rev" style="transition-delay:.08s"><div class="n">Meta</div><div class="l">Provedor de Tecnologia</div></div>
      <div class="s rev" style="transition-delay:.12s"><div class="n">LGPD</div><div class="l">dados isolados por empresa</div></div>
    </div>
  </div>
</section>

<section class="pad" id="seguranca" style="background:linear-gradient(180deg,#fff,#f6f9ff);border-top:1px solid var(--line-2)">
  <div class="shell">
    <div class="sec-head rev">
      <div class="eyebrow">Segurança &amp; LGPD</div>
      <h2 class="h2">Segurança no desenho, não como remendo.</h2>
      <p class="lead" style="margin-top:16px">Cada empresa roda isolada, com permissão por perfil e registro das ações sensíveis. Os dados são seus.</p>
    </div>
    <div class="cap-grid">
      <div class="valuecard rev"><div class="vh"><span class="vi"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></span><h3>Isolamento por empresa</h3></div><p>Cada tenant fica isolado no banco. Um cliente nunca enxerga o dado do outro.</p></div>
      <div class="valuecard rev"><div class="vh"><span class="vi"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span><h3>Conexão oficial &amp; criptografada</h3></div><p>Cloud API oficial da Meta, com tráfego criptografado entre o WhatsApp, a Meta e a Operax.</p></div>
      <div class="valuecard rev"><div class="vh"><span class="vi"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M9 13h6M9 17h4"/></svg></span><h3>Conformidade LGPD</h3></div><p>PII tratada com cuidado, trilha de auditoria e a opção de exportar ou excluir seus dados.</p></div>
    </div>
    <div class="ngs1 rev">
      <div class="ngs1-badge"><span class="ngs1-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></span>NGS1 · SBIS/CFM</div>
      <div class="ngs1-body">
        <h3>Preparada para o setor de saúde.</h3>
        <p>A Operax segue a norma <strong>NGS1 (SBIS/CFM)</strong> para Sistemas de Registro Eletrônico em Saúde, com controles de confidencialidade e integridade. Isso permite atender clínicas e profissionais de saúde com o cuidado que o setor pede.</p>
      </div>
    </div>
  </div>
</section>

<section class="finalcta" style="padding-top:64px">
  <div class="shell"><div class="cta-band rev">
    <h2>Ainda tem dúvida?</h2>
    <p>Chama no WhatsApp ou no chat do site. A gente explica planos e conexão. Sem teste grátis.</p>
    <div class="hero-cta"><a class="btn btn-white" href="https://wa.me/5511955022990?text=Oi!%20Quero%20conhecer%20a%20Operax.">Falar no WhatsApp</a></div>
  </div></div>
</section>
`;
